import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconPersonPlay = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconPersonPlay",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M192-492 92-592q-12-12-12-28t12-28l100-100q12-12 28-12t28 12l100 100q12 12 12 28t-12 28L248-492q-12 12-28 12t-28-12M400-80q-17 0-28-11t-12-29v-160q-50-4-99-11t-98-18q-17-4-27-19t-6-32 21-25 32-4q73 17 148 23t149 6 150-6 147-23q17-4 33 4t20 25-5 32-28 19q-49 11-98 18t-99 11v160q0 17-11 29t-29 11zm80-600q-50 0-85-35t-35-85 35-85 85-35 85 35 35 85-35 85-85 35m0 280q-33 0-56-23t-24-57 24-56 56-24 57 24 23 56-23 57-57 23m191-100-46-80q-5-9-5-20t5-20l46-80q5-10 14-15t20-5h90q11 0 20 5t14 15l46 80q5 9 5 20t-5 20l-46 80q-5 10-14 15t-20 5h-90q-11 0-20-5t-14-15"
  })
}));
IconPersonPlay.displayName = 'IconPersonPlay';